import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/slices/authSlice';
import { LayoutDashboard, Bell, ChevronDown, Calendar, Menu, X, User, Settings, LogOut } from 'lucide-react';

const Header = ({ title = 'Dashboard', onToggleMobileMenu, mobileMenuOpen }) => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setDropdownOpen(false);
    dispatch(logout());
    navigate('/admin/login');
  };

  return (
    <header className="top-header-bar">
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {/* Mobile Hamburger Button */}
        <button
          className="mobile-hamburger-btn"
          onClick={onToggleMobileMenu}
          title="Toggle Navigation Menu"
        >
          {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        {/* Page Title & Subtitle */}
        <div className="header-page-title-row">
          <div className="header-title-flex">
            <h1 className="header-page-title">{title}</h1>
            {title === 'Dashboard' && <LayoutDashboard size={20} color="#dc2626" />}
          </div>
          <span className="header-sub-greeting">
            Good morning, <strong>{user?.name || 'Admin'}</strong>! Here's your InfraEdge store performance overview.
          </span>
        </div>
      </div>

      {/* Right Actions */}
      <div className="header-actions-right">
        {/* Date Filter Pill */}
        <div className="header-date-pill">
          <Calendar size={16} color="#64748b" />
          <span>Aug 19, 2026</span>
          <ChevronDown size={14} color="#64748b" />
        </div>

        {/* Notification Bell */}
        <button className="notification-bell-btn" title="Store Notifications">
          <Bell size={18} />
          <span className="notification-count-badge">6</span>
        </button>

        {/* User Profile Dropdown */}
        <div style={{ position: 'relative' }} ref={dropdownRef}>
          <div
            className="header-user-profile"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div className="user-avatar-circle">
              {user?.name ? user.name.charAt(0).toUpperCase() : 'A'}
            </div>
            <div className="user-info-text">
              <span className="user-name-title">{user?.name || 'Admin Master'}</span>
              <span className="user-role-sub">Store Owner</span>
            </div>
            <ChevronDown size={16} color="#64748b" style={{ marginLeft: '4px', transform: dropdownOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
          </div>

          {/* Profile Dropdown Menu */}
          {dropdownOpen && (
            <div className="profile-dropdown-menu">
              <div className="dropdown-user-header">
                <span className="dropdown-user-name">{user?.name || 'InfraEdge Admin'}</span>
                <span className="dropdown-user-email">{user?.email || 'Info@infraedgeredlight.co.uk'}</span>
              </div>
              <div className="dropdown-divider"></div>
              <button
                className="dropdown-item-btn"
                onClick={() => { setDropdownOpen(false); navigate('/admin/settings'); }}
              >
                <User size={16} />
                <span>My Profile</span>
              </button>
              <button
                className="dropdown-item-btn"
                onClick={() => { setDropdownOpen(false); navigate('/admin/settings'); }}
              >
                <Settings size={16} />
                <span>Store Settings</span>
              </button>
              <div className="dropdown-divider"></div>
              <button
                className="dropdown-item-btn dropdown-logout-btn"
                onClick={handleLogout}
              >
                <LogOut size={16} />
                <span>Log Out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
